import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutExtBillCommentsQuickInfo extends Layout {
    labelTitle: Label;
    panelExtBillComments: Panel;
    sourceBillingComments: DataSource;
    tableExtBillComments: Table;
}
